import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
	ModalFooter,
} from 'reactstrap';

// import { deleteResidue } from '../../../../slices/thunks';

// import { setRequireCloseModal } from '../../../../slices/residue/reducer';

import { useSelector, useDispatch } from 'react-redux';
import { finalDestinationPrecertificationGuide, finalDestinationReceptionGuide } from '../../../../../slices/thunks';
import { createSelector } from 'reselect';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

const ConfirmPrecertificationGuidesModal = ({ guidesReception, isOpen, handlerToggleModal }) => {
	const dispatch = useDispatch();

	const selectorGuide = createSelector(
		state => state.Guides,
		guide => ({
			isPrecertifying: guide.isPrecertifying,
			isPrecertified: guide.isPrecertified,
			isPrecertifiedError: guide.isPrecertifiedError,
			requireCloseModal: guide.requireCloseModal
		})
	);

	const {
		isPrecertifying,
		isPrecertified,
		isPrecertifiedError,
		requireCloseModal
	} = useSelector(selectorGuide);


	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: false,
		initialValues: {
			guides: guidesReception
		},
		validationSchema: Yup.object({
		}),
		onSubmit: values => {
			const dataGuide = {
				guides: guidesReception
			};
			dispatch(finalDestinationPrecertificationGuide(dataGuide));
		},
	});

	function handlerOkModal() {
		validation.submitForm();
	}

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader >Confirmar Precertificacion</ModalHeader>
				<ModalBody className='text-center p-3'>
					{/* <lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon> */}
					<div className='mt-2'>
						<h5 className='mb-3'>
							¡Atención! Estás a punto de confirmar la precertificacion de las guías seleccionados
						</h5>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='hstack gap-2 justify-content-center'>
						<Button type='button' onClick={() => handlerToggleModal()} className='btn-danger btn-label'><i className="icon-x label-icon"></i> Cancelar</Button>
						<button
							className='btn btn-label btn-primary'
							onClick={() => handlerOkModal()}
							disabled={isPrecertifying}
						>
							{isPrecertifying ? (
								<i className='label-icon'><Spinner size='sm' /></i>
							) : <i className={`${Icons.check2} label-icon`}></i>}
							Confirmar
						</button>
					</div>
				</ModalFooter>
			</Modal>
		</div>
	);
};

export default ConfirmPrecertificationGuidesModal;